import template from './ps-formula.html';
import Formula from './models.js';

class ComponentViewModel
{
	constructor(params)
	{
		this.depth = params.depth ?? 0;
		this.formula = ko.isObservable(params.formula) && params.formula() instanceof Formula.Formula ? 
			params.formula :
			ko.observable(new Formula.Formula(ko.isObservable(params.formula) ? params.formula() : params.formula));
		this.functions = ko.observableArray([]);
		this.ctx_list = ko.observableArray([]);
		this.value_list = ko.observableArray([]);
		this.selected_function = ko.observable(new Formula.Function());
		this.save_formula = params.save_formula;

		this.formula_errors = ko.computed(() => {

			if (!this.selected_function().function_uuid())
				return [];
			// check formula for errors
			let errors = [];
			let required_args = 0;
			let is_variadic = false;
			let param_count = 0;
			
			for (let param of this.selected_function().params())
			{
				if (!param.is_optional())
					required_args++;

				if (param.is_variadic())
					is_variadic = true;

				param_count++;
			}

			if (this.formula().parameters().length < required_args)
				errors.push('Minimum required arguments not satisfied');

			if (!is_variadic && this.formula().parameters().length > param_count)
				errors.push('Too many arguments provided');
			
			for (const [i, param] of this.formula().parameters().entries())
			{
				let current_arg_num = Math.min(i,param_count - 1); //caters for variadic functions
				let param_basetype = this.selected_function().params()[current_arg_num].basetype();

				if (param.parameter_type() === 'formula' && param.formula())
				{
					let nested_function = this.functions().find(
						fn => fn.function_uuid() === param.formula().function_uuid()
					);

					if (nested_function.return_basetype() === 'any')
						continue;
					else if (nested_function.return_basetype() !== param_basetype)
						errors.push(`Formula @ parameter (${i}) return data type: ${nested_function.return_basetype()}, differs from parameter type: ${param_basetype}`);
				} else if (param.parameter_type() === 'value')
				{
					let value;
					try {
						value = JSON.parse(param.parameter_value());
					} catch {
						console.error('Unable to parse value to JSON', param.parameter_value());
						errors.push(`Unable to parse value @ parameter (${i})`);
						continue;
					};

					let valid = this.param_value_is_valid(
						param_basetype,
						value,
						this.selected_function().params()[current_arg_num].is_optional()
					);
					if (!valid)
						errors.push(`Value @ parameter (${i}) has basetype: ${typeof value}, expected: ${param_basetype}.`);

				} else if (param.parameter_type() === 'context') {
					// jsonpath validator could be added here (library dependency)
					if (!param.context_selector() || !param.context_selector().startsWith('$'))
						errors.push(`Context @ parameter (${i} needs to start with a $`);
				}

			}

			return errors;
		}).extend({ rateLimit: 400 });

		if (params)
			this.set(params);

		if (!this.formula().function_uuid())
			this.formula().is_set(true);

		this.formula().function_uuid.subscribe(() => {
			this.set_selected_function();
		});

		this.set_selected_function();

	}

	set(params) 
	{
	    if (params.functions) 
	    {
	    	let functions_map = [];
	    	let functions = ko.isObservable(params.functions) ? 
					ko.unwrap(params.functions) : 
					params.functions;

			for (const func of functions) 
			{
				functions_map.push(
					func instanceof Formula.Function ?
					func :
					new Formula.Function(func)
				);
			}

			this.functions(functions_map);
    	}

    	if (params.ctx_list)
    		this.ctx_list(ko.isObservable(params.ctx_list) ? ko.unwrap(params.ctx_list) : params.ctx_list);

    	if (params.value_list)
    		this.value_list(ko.isObservable(params.value_list) ? ko.unwrap(params.value_list) : params.value_list);
	}

	delete_param()
	{
		const arr = this.formula().parameters();
		if (arr.length == 0)
			return;

		arr.pop();
		this.formula().parameters([...arr]);
	}

	add_param() 
	{
	    const arr = this.formula().parameters();
	    const param = new Formula.Parameter({
	        idx: arr.length,
	        parameter_type: 'value',
	        parameter_value: ''
	    });
	    arr.push(param);
	    this.formula().parameters([...arr]);
	}

	save() 
	{
		const data = ko.toJSON(this.formula);
		this.save_formula(JSON.parse(data));
	}

	set_selected_function()
	{
		let new_function = this.functions().find(fn => fn.function_uuid() === this.formula().function_uuid());
		if (!new_function)
			return;
		this.selected_function(new_function);

		// update formula accordingly
		this.formula().function_name(this.selected_function().function_name());

	}

	param_value_is_valid(parameter_basetype,value,is_optional)
	{
		const type = typeof value; 
		if (is_optional && (type == null || type == undefined ) || parameter_basetype == 'any')
			return true;

		if (parameter_basetype === 'array')
		{
			return type === 'array' && Array.isArray(value);
		} else if (parameter_basetype == 'object')
		{
			return type === 'object' && !Array.isArray(value);
		} else {
			return parameter_basetype === type; 
		}
	}
}

export default {
	name: 'ps-formula',
	viewModel: ComponentViewModel,
	module_type: 'ko',
	template: template
};

